import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Dropzone from 'react-dropzone';
import papa from 'papaparse';

class UploadOptionsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uploading: false,
			error: null
		};
	}

	onDrop = (files) => {
		if (files.length === 0) {
			this.setState({ error: 'No file selected' });
			return;
		}

		this.setState({ uploading: true, error: null });

		papa.parse(files[0], {
			complete: (res) => {
				try {
					// Filter out empty rows
					const trimmedData = res.data.filter(row => {
						return row.length > 0 && row[0] && row[0].trim() !== '';
					});

					// Extract first column values (skip header row)
					const options = trimmedData
						.slice(1) // Skip header row
						.map(row => row[0].trim())
						.filter(value => value !== ''); // Remove empty values

					if (options.length === 0) {
						this.setState({ 
							error: 'No valid options found in the first column',
							uploading: false 
						});
						return;
					}

					// Call the parent's callback with the extracted options
					this.props.onUpload(options);
					this.props.toggle();
				} catch (e) {
					console.error(e);
					this.setState({ 
						error: 'Error processing CSV file',
						uploading: false 
					});
				}
			},
			error: (error) => {
				console.error(error);
				this.setState({ 
					error: 'Error reading CSV file',
					uploading: false 
				});
			}
		});
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { uploading, error } = this.state;

		return (
			<Modal isOpen={isOpen} toggle={toggle} className="medium">
				<div className="modalHeader pb-0">
					<button 
						onClick={toggle} 
						style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}
					>
						<i className='las la-times'></i>
					</button>
					<div className="headerContainer">
						<h1>Upload Options from CSV</h1>
					</div>
				</div>

				<ModalBody className="modalBody">
					<div className="sectionBody w-100">
						<div className='mb-20'>
							<h4 className='mb-10'>
								Upload a CSV file to import options. Only the first column will be used.
							</h4>
							<p className='small gray'>
								The first row will be treated as a header and skipped.
							</p>
						</div>

						{error && (
							<div className='mb-20' style={{ 
								padding: '10px', 
								backgroundColor: '#fee', 
								border: '1px solid #fcc',
								borderRadius: '5px',
								color: '#c00'
							}}>
								{error}
							</div>
						)}

						<Dropzone
							accept=".csv,text/csv"
							className="clickable dropzone-details banner mb-10"
							style={{ height: 200 }}
							onDrop={this.onDrop}
							disabled={uploading}
						>
							<div>
								<div className="addIcon">
									<i className="las la-plus"></i>
								</div>
								<p className='text-c'>
									{uploading ? 'Processing...' : (
										<>
											Add CSV File<br />
											or <span style={{ color: '#2B83F1' }}>Browse</span>
										</>
									)}
								</p>
							</div>
						</Dropzone>
					</div>
				</ModalBody>

				<div className='flex mt-20'>
					<button
						onClick={toggle}
						className='neu ml-a mr-15'
						disabled={uploading}
					>
						Cancel
					</button>
				</div>
			</Modal>
		);
	}
}

export default UploadOptionsModal;
